<ng-container *transloco="let t">
  @switch (screenType) {
    @case ("canceled") {
      <div class="payment-callback">
        <h1 class="title warn">{{ t("paymentCanceled") }}</h1>
        <p class="message">{{ message ?? t("paymentCanceledMessage") }}</p>

        <p-button
          [label]="t('goToReservation')"
          icon="pi pi-arrow-left"
          severity="warn"
          class="cta-button"
          [outlined]="true"
          (click)="goToHome()"
        />
      </div>
    }

    @case ("success") {
      <div class="payment-callback">
        <h1 class="title success">{{ t("paymentSuccess") }}</h1>
        <p class="message">{{ t("paymentSuccessMessage") }}</p>

        <p-button
          [label]="t('continue')"
          icon="pi pi-check"
          severity="primary"
          class="cta-button"
          (click)="goToHome()"
        />
      </div>
    }

    @case ("error") {
      <div class="payment-callback">
        <h1 class="title error">{{ t("paymentError") }}</h1>
        <p class="message">{{ message ?? t("paymentErrorMessage") }}</p>

        <p-button
          [label]="t('goToReservation')"
          icon="pi pi-arrow-left"
          severity="danger"
          class="cta-button"
          [outlined]="true"
          (click)="goToHome()"
        />
      </div>
    }

    @case ("pending") {
      <div class="payment-callback">
        <h1 class="title purple">{{ t("paymentPending") }}</h1>
        <p class="message">{{ message ?? t("paymentPendingMessage") }}</p>

        <p-button
          [label]="t('goToReservation')"
          icon="pi pi-arrow-left"
          severity="help"
          class="cta-button"
          [outlined]="true"
          (click)="goToHome()"
        />
      </div>
    }

    @case ("declined") {
      <div class="payment-callback">
        <h1 class="title error">{{ t("paymentDeclined") }}</h1>
        <p class="message">{{ message ?? t("paymentDeclinedMessage") }}</p>

        <p-button
          [label]="t('goToReservation')"
          icon="pi pi-arrow-left"
          severity="danger"
          class="cta-button"
          [outlined]="true"
          (click)="goToHome()"
        />
      </div>
    }

    @case ("denied") {
      <div class="payment-callback">
        <h1 class="title error">{{ t("paymentDenied") }}</h1>
        <p class="message">{{ message ?? t("paymentDeniedMessage") }}</p>

        <p-button
          [label]="t('goToReservation')"
          icon="pi pi-arrow-left"
          severity="danger"
          class="cta-button"
          [outlined]="true"
          (click)="goToHome()"
        />
      </div>
    }

    @case ("threedsFail") {
      <div class="payment-callback">
        <h1 class="title error">{{ t("paymentThreedFail") }}</h1>
        <p class="message">{{ message ?? t("paymentThreedFailMessage") }}</p>

        <p-button
          [label]="t('goToReservation')"
          icon="pi pi-arrow-left"
          severity="danger"
          class="cta-button"
          [outlined]="true"
          (click)="goToHome()"
        />
      </div>
    }

    @case ("voided") {
      <div class="payment-callback">
        <h1 class="title success">{{ t("paymentVoided") }}</h1>
        <p class="message">{{ t("paymentVoidedMessage") }}</p>

        <p-button
          [label]="t('continue')"
          icon="pi pi-check"
          severity="primary"
          class="cta-button"
          (click)="goToHome()"
        />
      </div>
    }

    @case ("refunded") {
      <div class="payment-callback">
        <h1 class="title success">{{ t("paymentRefunded") }}</h1>
        <p class="message">{{ t("paymentRefundedMessage") }}</p>

        <p-button
          [label]="t('continue')"
          icon="pi pi-check"
          severity="primary"
          class="cta-button"
          (click)="goToHome()"
        />
      </div>
    }

    @default {
      <div class="payment-callback">
        <h1 class="title default">{{ t("paymentLoading") }}</h1>
        <p class="message">{{ t("paymentLoadingMessage") }}</p>
      </div>
    }
  }
</ng-container>
